<template lang="pug">
.list-layout

	.section

		.title( v-if='layout.title' ) {{ layout.title }}

		//- The reason why we have the whole logic to tell if the value is false and
		//- then convert it to a string and see if that string is false, is because
		//- JS natural !== will not work for values that have "false" listed as their
		//- value. (Take a look at mappedInGis property) Because of this, we need to
		//- see if the value is equal to false twice. Our first check makes sure that
		//- there is an intentional "false" value and not a null/undefined value.
		//- After that, because we know we have a value that is set there intentionally
		//- as false, we check to see if we try to turn the value into a string that it
		//- remains as false.
		.list-item(
			v-for='( item, key ) in layout.items'
			v-if='( typeof item !== "object" && parentObj[key] ) || ( parentObj[key] === false || parentObj[key] === 0 )'
			:class='`item-${key}`'
		)
			p.sub-title {{ item }}
			p.value.link(
				v-if='linkCheck( key )'
				@click='redirect( parentObj[key] )'
			) {{ parentObj[key] }}
			p.value(v-else-if='parentObj[key] !== undefined') {{ displayValueOf( parentObj[key] ) }}

		.list-item(
			v-else-if='typeof item === "object" && !item.title && parentObj[key]'
			v-for='( objectItem, objectKey ) in item.items'
			:class='`item-${key}`'
		)
			p.sub-title {{ objectItem }}
			.value-wrapper(v-if='Array.isArray( parentObj[key] )')
				p.value(v-for='value in parentObj[key]') {{ displayValueOf( value[objectKey] )}}
					span.facilityNumber( v-if='objectItem === "Facilities"' ) {{ ` No. ${displayValueOf( value['number'] )}` }}
			p.value(v-else) {{ displayValueOf( parentObj[key][objectKey] ) }}

		list-layout(
			v-else-if='typeof item === "object" && validParent( item, key ) '
			:layout='item'
			:parentObj='item.parent || parentObj[key]'
			:class='`list-layout-${key}`'
		)
</template>

<script>
import { FormatDate } from '@/lib/utils';

export default {
	name : 'list-layout',

	props : {

		// all this is, is where the data is actually at so that way we can have
		// a reference, layout only contains the data key and the title that
		// corresponds with it.
		parentObj : {
			type     : Object,
			required : true,
		},

		layout : {
			type     : Object,
			required : true,
		},

	},

	methods : {

		validParent( item, key ) {

			const parentObj = this.parentObj[key] || ( item.parent === this.parentObj );

			if ( parentObj ) {
				return true;
			}

			return false;

		},

		linkCheck( val ) {
			const lowerCasedVal = val.toString().toLowerCase();
			const includesLink  = lowerCasedVal.includes( 'link' );

			return includesLink;
		},

		redirect( link ) {
			window.open( link, '_blank' );
		},

		displayValueOf( val ) {
			if ( /\d{4}-\d{2}-\d{1,2}T\d{2}:\d{2}:\d{2}.\d{3}Z/g.test( val ) ) {
				return this.dateFormat( val );
			}

			if ( typeof val === 'boolean' ) {
				return val ? 'Yes' : 'No';
			}

			return val;
		},

		dateFormat( date ) {
			return FormatDate( date, 'MMMM D, YYYY', 'GMT' );
		},

	}

};
</script>

<style lang="scss">
.list-layout {
	width: 100%;
	transform: translate( 0, -30px );
	opacity: 0;
	max-height: 0px;
	transition: transform 0.2s ease, opacity 0.2s ease, max-height 0.2s ease, padding-bottom 0.2s ease; // + Leave the padding bottom.

	&:not(.slide-in) {
		pointer-events: none;
	}

	&.slide-in,
	&.slide-in .list-layout {
		position: relative;
		transform: translate( 0, 0 );
		opacity: 1;
		max-height: 1500px;
	}

	.list-layout .section:nth-child(1) > .title {
		margin-top: 30px;
	}

	.section {
		display: flex;
		flex-flow: row wrap;
		justify-content: flex-start;

		&:nth-child(1) > .title {
			margin-top: 0;
		}

		.title {
			color: $color-primary;
			width: 100%;
			margin: 30px 0 5px 0;
		}

		.list-item {
			flex: 0 0 33.33%;
			margin-top: 10px;
			padding-right: 15px;

			.link {
				cursor: pointer;
				text-decoration: underline;
			}

			p {
				text-align: left;

				&.sub-title {
					color: $input-color-faded;
				}
			}
		}
	}
}
</style>
